export default __webpack_public_path__ + "static/media/auth0.1770836c.svg";